import { render } from "./SearchApplianceIconItem.vue?vue&type=template&id=3f8bd36a&scoped=true&ts=true"
import script from "./SearchApplianceIconItem.vue?vue&type=script&lang=ts"
export * from "./SearchApplianceIconItem.vue?vue&type=script&lang=ts"

import "./SearchApplianceIconItem.vue?vue&type=style&index=0&id=3f8bd36a&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8bd36a"]])

export default __exports__